export default {
  type: 'outcome',
  config: {
    afterDeserialize: function afterDeserialize(data) {
      return data;
    },
    relationships: {
      network: {
        type: 'network'
      },
      provider: {
        type: 'provider'
      },
      services: {
        type: 'service'
      }
    }
  }
};
//# sourceMappingURL=outcome.js.map